
/* INT: Global observer/cleanup registry — initialized once per page */
if (!window.__intCleanupRegistry) window.__intCleanupRegistry = [];

/* ─────────────────────────────────────────────────────────────────────────
   INITIAL CLOAK HANDOFF — reduced 2026-08-14.
   This was 458 lines of two-phase cloak for the StarApps Variant Images app
   (VIA): hide the slideshow and thumbstrip, wait for the app's ready signal,
   reveal on a 7-14s fallback. The app is uninstalled, so
   `window._starapps_theme_settings` is undefined and the block took its
   "VIA embed is not active" early return on every single page load — every
   reveal path, watchdog and timeout below it was unreachable.
   Kept here are the three things that early return actually did:
     1. the cleanup registry above (used elsewhere in this file),
     2. clearing the slideshow's cloak animation/opacity,
     3. dispatching int:gallery:settled. ⚑ Despite the name, that event is still
        LIVE theme plumbing, not app residue: this file fires it here on load
        and again on every colour-swatch fadein, and several listeners below
        plus sections/product-framedprint.liquid use it to re-apply the
        gallery height clamp and slide aspect ratios. It does NOT fire on a
        Frame Size change, which is why
        snippets/int-variant-gallery-framed.liquid fires it after every swap.
   A fourth keeper — removing the #starapps-cloak-early / -ss / -cloak <style>
   nodes — was dropped 2026-08-17 after being proven dead: the served product
   HTML carries no id="starapps-cloak*" element, nothing in the theme creates
   one, and no StarApps script loads. The only matches left in the page source
   were this comment and the removal loop itself.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  var ss = document.querySelector('[data-product-slideshow]');
  if (ss) {
    ss.style.webkitAnimation = 'none';
    ss.style.animation       = 'none';
    ss.style.opacity         = '1';
  }
  setTimeout(function () {
    document.dispatchEvent(new CustomEvent('int:gallery:settled'));
  }, 200);
})();

;

(function() {
  /* ── Flickity detection — tries multiple strategies for iOS/VIA ── */
  function getFlkty(ss) {
    var _Flk = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);
    if (!_Flk || !_Flk.data) return null;
    var el = ss || document.querySelector('[data-product-slideshow]');
    if (!el) return null;
    // Standard lookup
    var f = _Flk.data(el);
    if (f) return f;
    // VIA may init on a child — try .flickity-enabled child
    var enabled = el.querySelector('.flickity-enabled');
    if (enabled && enabled !== el) { f = _Flk.data(enabled); if (f) return f; }
    // Scan element own properties for Flickity-duck instance
    try {
      var keys = Object.getOwnPropertyNames(el);
      for (var i = 0; i < keys.length; i++) {
        var v = el[keys[i]];
        if (v && typeof v === 'object' && typeof v.select === 'function' && typeof v.resize === 'function') return v;
      }
    } catch(e) {}
    return null;
  }
  window.__intGetFlkty = getFlkty;

  /* ── Collapse slideshow container to viewport height on mobile ───
     Root cause of gap: Pipeline CSS uses padding-top:var(--default-ratio)
     on .product__grid--slides for aspect-ratio. Flickity viewport may be
     shorter than the padding, leaving whitespace below the image.
     Fix: after VIA settle, force container height = viewport height.     */
  /* INT v24: added throttle + write-only-if-different guard.
     Previously this function wrote to ss.style.height on every call,
     which on a 60ms poll cycle caused 16 style writes per second even
     when the value wasn't changing. Now: only write if h differs from
     last write by > 1px. */
  var _lastFixH = 0;
  var _lastFixT = 0;
  function fixMobileContainerHeight() {
    if (window.innerWidth >= 768) return;
    var now = Date.now();
    if (now - _lastFixT < 100) return; /* throttle to 10Hz max */
    var ss = document.querySelector('[data-product-slideshow]');
    if (!ss) return;
    var vp = ss.querySelector('.flickity-viewport');
    if (!vp) return;
    if (vp.__intVpLocked) return;
    var h = vp.offsetHeight;
    if (h < 80) return;
    if (Math.abs(h - _lastFixH) <= 1) return; /* no meaningful change */
    _lastFixH = h;
    _lastFixT = now;
    ss.style.height = h + 'px';
    ss.style.minHeight = h + 'px';
    ss.style.paddingTop = '0';
    ss.style.paddingBottom = '0';
  }
  window.__intFixMobileContainerHeight = fixMobileContainerHeight;

  /* ── Force-load blank thumb images injected by VIA on iOS ────────
     VIA injects .media__thumb img with no src (lazy placeholders).
     iOS throttled IntersectionObserver never triggers them.
     Fix: after settle, set src from data-src or srcset.              */
  function restoreThumbImages() {
    document.querySelectorAll('.media__thumb img, .media__thumb__wrapper img').forEach(function(img) {
      if (img.src && img.src !== window.location.href && img.src !== '') return;
      var src = img.dataset.src || img.dataset.lazySrc || img.dataset.original;
      if (!src && img.srcset) {
        src = img.srcset.split(',')[0].trim().split(' ')[0];
      }
      if (src) { img.src = src; img.loading = 'eager'; }
    });
  }

  /* ── Size variant resize (non-colour variant:change) ─────────────  */
  var _lastSwatchClick = 0;
  var _ready = false;
  document.addEventListener('click',      function() { _ready = true; }, { once: true, capture: true });
  document.addEventListener('touchstart', function() { _ready = true; }, { once: true, capture: true, passive: true });
  document.addEventListener('click', function(e) {
    if (e.target && e.target.closest && e.target.closest('.int-gswatch')) {
      _lastSwatchClick = Date.now();
    }
  }, true);

  /* INT v24: removed flkty.resize() call on variant:change.
     Per diagnostic: this was causing the second setGallerySize call
     3-9ms after Flickity's own select pipeline already resized.
     Flickity's native variant:change handling plus the cloak handoff
     in int-gallery-swatches.liquid are sufficient. We still fix the
     container height (CSS-level, doesn't trigger Flickity). */
  document.addEventListener('variant:change', function() {
    if (!_ready) return;
    if (Date.now() - _lastSwatchClick < 1400) return;
    setTimeout(function() {
      fixMobileContainerHeight();
    }, 400);
  });

  /* Run after every VIA settle */
  function repairSlideHeights() {
    var ss = document.querySelector('[data-product-slideshow]');
    var vp = ss && ss.querySelector('.flickity-viewport');
    if (!vp) return;
    var vpH = parseFloat(vp.style.height) || vp.offsetHeight;
    if (vpH < 80) return;
    /* Removed: inline height stamping on slides locked cells to
       the first slide's height, preventing adaptiveHeight from
       working on taller slides. VP height is now managed by
       _intSetVPHeight in int-gallery-swatches.liquid. */
    var sentinelSlide = ss.querySelector('[data-media-slide].int-sentinel-slide');
    if (sentinelSlide) {
      var sentinelId = sentinelSlide.dataset.mediaId || sentinelSlide.dataset.mediaSelect;
      if (sentinelId) {
        document.querySelectorAll('[data-slideshow-thumbnail][data-media-select="' + sentinelId + '"]').forEach(function(t) {
          t.classList.add('int-sentinel-thumb');
        });
      }
    }
  }

  /* INT v24: removed 200/700/1600ms poll cascade — was calling
     flkty.resize() during settle window, causing the double-setGallerySize
     jitter reported by Claude Chrome diagnostic.
     Now fires once per settle event, debounced. */
  var _settleRunTimer = null;
  document.addEventListener('int:gallery:settled', function() {
    clearTimeout(_settleRunTimer);
    _settleRunTimer = setTimeout(function() {
      fixMobileContainerHeight();
      restoreThumbImages();
      repairSlideHeights();
    }, 300);
  });

  /* INT v24: removed [1500, 3000]ms double initial-load cycle.
     Single pass after DOMContentLoaded is enough — anything running
     later rides on int:gallery:settled or variant:change handlers. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(function() {
        fixMobileContainerHeight();
        restoreThumbImages();
      }, 600);
    });
  } else {
    setTimeout(function() {
      fixMobileContainerHeight();
      restoreThumbImages();
    }, 600);
  }
})();

;

(function () {
  'use strict';
  var SETTLE_MUT = 600, SETTLE_MAX = 2500;
  var TARGETS = '.media__thumb__holder, .media__thumb__wrapper';
  var SWATCH_SELECTOR = '.int-gswatch';
  var settleTimer = null, sliderObs = null, thumbObs = null, watching = false;

  function setThumbs(opacity, dur) {
    document.querySelectorAll(TARGETS).forEach(function (el) {
      el.style.transition = 'opacity ' + dur + ' ease';
      el.style.opacity = opacity;
    });
  }
  function recloak() { setThumbs('0', '0s'); }
  var lastFadein = 0;
  function fadein() {
    lastFadein = Date.now();
    setThumbs('1', '0.2s');
    stopWatching();
    document.dispatchEvent(new CustomEvent('int:gallery:settled'));
  }
  function scheduleUncloak() { clearTimeout(settleTimer); settleTimer = setTimeout(fadein, SETTLE_MUT); }
  function startWatching() {
    if (watching) return;
    watching = true;
    var slider = document.querySelector('[data-product-slideshow] .flickity-slider');
    if (slider) {
      sliderObs = new MutationObserver(function () { scheduleUncloak(); });
      sliderObs.observe(slider, { childList: true });
      if (window.__intCleanupRegistry) {
        window.__intCleanupRegistry.push(function() {
          if (sliderObs) { sliderObs.disconnect(); sliderObs = null; }
          watching = false;
          clearTimeout(settleTimer);
        });
      }
    }
    /* Also watch thumb img src changes — VIA updates thumbnail src AFTER
       slider mutations stop. Without this, the debounce fires during slider
       silence while thumbs still show the old colour. */
    var thumbRoot = document.querySelector('.media__thumb__wrapper, .media__thumb__holder');
    if (thumbRoot) {
      thumbObs = new MutationObserver(function () { scheduleUncloak(); });
      thumbObs.observe(thumbRoot, { subtree: true, attributes: true, attributeFilter: ['src'] });
    }
  }
  function stopWatching() {
    if (!watching) return;
    watching = false;
    clearTimeout(settleTimer);
    if (sliderObs) { sliderObs.disconnect(); sliderObs = null; }
    if (thumbObs)  { thumbObs.disconnect();  thumbObs = null; }
  }
  function isColorSwatch(el) {
    if (!el) return false;
    if (el.matches('.int-gswatch')) return true;
    var wrap = el.closest('[data-select-label]');
    if (wrap) return /color|colour|farbe|couleur/i.test(wrap.getAttribute('data-select-label') || '');
    return el.matches('.swatch__link');
  }
  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    var target = e.target && e.target.closest ? e.target.closest(SWATCH_SELECTOR) : null;
    if (!target || !isColorSwatch(target)) return;
    if (target.classList.contains('int-gswatch--active')) return;
    if (Date.now() - lastFadein < 600) return;
    recloak();
    clearTimeout(settleTimer);
    /* Was: branch on whether the VIA app had signalled data-ready, waiting
       SETTLE_MAX for it to finish rebuilding the gallery. The app is gone and
       `__intVIADataReady` is never set, so this always took the short path.
       Our own gallery swap is synchronous — 350ms is the settle. */
    stopWatching();
    settleTimer = setTimeout(fadein, 350);
  }, true);
})();
